import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label } from "reactstrap";

function CreateNew(props) {
  const { onCancel, onCreate, addSplitCheckbox = false, handleChanges } = props;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [split, setSplit] = useState(false);

  const handleCreate = () => {
    handleChanges(false);
    onCreate({ name, description, split_by_client: split });
  };

  const handleCancel = () => {
    handleChanges(false);
    onCancel();
  }

  useEffect(() => {
    if(
      name.trim().length ||
      description.trim().length ||
      split
    ) {
      handleChanges(true);
    } else {
      handleChanges(false);
    }
  // eslint-disable-next-line
  }, [name, description, split])

  return (
    <Form onSubmit={e => e.preventDefault()}>
      <FormGroup row>
        <Label sm={2}>Name:</Label>
        <Col sm={10}>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="*Required"
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={2}>Description:</Label>
        <Col sm={10}>
          <Input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="*Optional"
          />
        </Col>
      </FormGroup>
      {addSplitCheckbox && (
      <Col
      sm={{
        size: 10,
        offset: 2
      }}
    >
      <FormGroup check className="split-check">
        <Label
          check
          for="split"
        >
          Split Royalty Reporting Out By Client
        </Label>
        <Input
          id="split"
          name="check"
              type="checkbox"
              checked={split}
              onChange={() => setSplit(!split)}
              style={{
              cursor: "pointer",
            }}
        />
      </FormGroup>
    </Col>
      )}

      <FormGroup row>
          <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <Button onClick={handleCancel}>Cancel</Button>
            {'  '}
            <Button className="me-md-2 promote" onClick={handleCreate} disabled={name.length < 1}>
              Save
            </Button>
          </div>
      </FormGroup>
    </Form>
  );
}

export default CreateNew;
